import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { useSignalRConnection } from 'utils/useSignalRConnection';
import { ENV } from '../../../../constants';
import { GeneralModel } from 'modules/models';
import { useStyles } from './styles';

export interface IDownloadsNotificationsProps {
  isAuthenticated: boolean;
  userId: string;
  fetchInProgressWidgetExports: (query: GeneralModel.IQueryParams) => void;
}

const DownloadsNotifications = ({ isAuthenticated, userId, fetchInProgressWidgetExports }: IDownloadsNotificationsProps) => {
  const classes = useStyles();
  const history = useHistory();
  let location = useLocation();

  const navigateToDownloads = () => {
    history.push('/downloads');
  };

  const connection = useSignalRConnection({
    url: ENV.API.URL + '/reportreadyhub',
    connectionCondition: isAuthenticated && !!userId,
    connectionKey: 'ReportReadyMessage',
    withAccessFactory: false,
    onMessageReceive: (userType, recipientId, message) => {
      const data = typeof message === 'string' ? JSON.parse(message) : message;
      if (userId === recipientId) {
        if (location.pathname?.includes('wfm-expanded') || location.pathname?.includes('daily-log-expanded')) {
          fetchInProgressWidgetExports({ clientSidePaging: true, inProcessOnly: true });
        }
        if (data?.isFileUploaded) {
          toast.success(
            <>
              Download is ready. Click{' '}
              <Link
                to={'/downloads'}
                className={classes.navigationLink}
                onClick={e => {
                  e?.preventDefault();
                  toast.dismiss(data.ExportRequestId);
                }}
              >
                here
              </Link>{' '}
              to proceed
            </>,
            {
              theme: 'colored',
              toastId: data.ExportRequestId,
              onClick: () => {
                toast.dismiss(data.ExportRequestId);
                navigateToDownloads();
              },
              onClose: () => toast.dismiss(data.ExportRequestId),
            }
          );
        } else {
          toast.error('Download failed. Please go back and try again', {
            theme: 'colored',
          });
        }
      }
    },
  });

  useEffect(() => {
    if (!isAuthenticated) {
      toast.dismiss();
      if (connection) {
        connection.stop();
      }
    }
  }, [isAuthenticated, connection]);

  return null;
};

export default DownloadsNotifications;
